if (!customElements.get('mm-gallery-product')) customElements.define('mm-gallery-product', class extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    this.ready = true;
    this.querySelector('.mmg-native').hidden = true;
    this.querySelector('.mmg-sizes').hidden = false;
    const materialPicker = this.querySelector('.mmg-materials');
    if (materialPicker) materialPicker.hidden = false;
    this.addEventListener('change', e => {
      if (e.target.matches('[name="mmg-material"]')) {
        const selected = this.querySelector('[name="mmg-size"]:checked');
        const choices = [...this.querySelectorAll('[name="mmg-size"]')].filter(r => r.dataset.material === e.target.value);
        const next = choices.find(r => r.dataset.size === selected?.dataset.size) || choices.find(r => !r.disabled) || choices[0];
        if (next) { next.checked = true; this.updateVariant(next); }
      } else if (e.target.matches('[name="mmg-size"]')) this.updateVariant(e.target);
    });
    this.addEventListener('click', e => {
      const tab = e.target.closest('[data-mmg-view]');
      if (tab) {
        this.dataset.view = tab.dataset.mmgView;
        this.querySelectorAll('[data-mmg-view]').forEach(t => t.setAttribute('aria-pressed', String(t === tab)));
        this.querySelector('.mmg-room-notice').hidden = this.dataset.view !== 'room';
      }
      const open = e.target.closest('[data-mmg-open],[data-mmg-zoom]');
      if (open) {
        const name = open.hasAttribute('data-mmg-zoom') ? 'image' : open.dataset.mmgOpen;
        const dialog = this.querySelector(`[data-mmg-dialog="${name}"]`);
        this.lastFocus = open;
        if (name === 'image') this.querySelector('.mmg-zoom-notice').hidden = this.dataset.view !== 'room';
        dialog.showModal();
        this.savedOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
      }
      const choose = e.target.closest('[data-mmg-select]');
      if (choose) {
        const radio = this.querySelector(`[name="mmg-size"][value="${choose.dataset.mmgSelect}"]`);
        if (radio && !radio.disabled) { radio.checked = true; this.updateVariant(radio); this.closeDialog(choose.closest('dialog')); }
      }
      const close = e.target.closest('[data-mmg-close]');
      if (close) this.closeDialog(close.closest('dialog'));
      if (e.target.matches('dialog')) this.closeDialog(e.target);
    });
    this.querySelectorAll('dialog').forEach(d => d.addEventListener('close', () => {
      document.body.style.overflow = this.savedOverflow || '';
      this.lastFocus?.focus();
    }));
    this.onPopState = () => {
      const id = new URL(location.href).searchParams.get('variant');
      const radio = id && this.querySelector(`[name="mmg-size"][value="${id}"]`);
      if (radio) { radio.checked = true; this.updateVariant(radio, false); }
    };
    window.addEventListener('popstate', this.onPopState);
  }
  disconnectedCallback() { window.removeEventListener('popstate', this.onPopState); }
  closeDialog(dialog) { dialog.close(); }
  updateVariant(radio, updateUrl = true) {
    this.querySelector('[name="id"]').value = radio.value;
    const material = radio.dataset.material;
    this.querySelectorAll('[data-mmg-material]').forEach(el => { el.hidden = el.dataset.mmgMaterial !== material; });
    this.querySelectorAll('[name="mmg-material"]').forEach(el => { el.checked = el.value === material; });
    const kind = material?.includes('Acrylic') ? 'acrylic' : 'paper';
    this.querySelectorAll('[data-mmg-material-copy]').forEach(el => { el.hidden = el.dataset.mmgMaterialCopy !== kind; });
    const roomTab = this.querySelector('[data-mmg-view="room"]');
    const hasRoom = kind === 'acrylic' ? this.dataset.hasAcrylicRoom === 'true' : this.dataset.hasPaperRoom === 'true';
    if (roomTab) roomTab.hidden = !hasRoom;
    if (!hasRoom && this.dataset.view === 'room') {
      this.dataset.view = 'art';
      this.querySelectorAll('[data-mmg-view]').forEach(t => t.setAttribute('aria-pressed', String(t.dataset.mmgView === 'art')));
      this.querySelector('.mmg-room-notice').hidden = true;
    }

    this.querySelector('[data-mmg-price]').textContent = radio.dataset.money;
    const button = this.querySelector('[name="add"]');
    button.disabled = radio.dataset.available !== 'true';
    button.querySelector('span').textContent = button.disabled ? this.dataset.soldLabel : `${this.dataset.addLabel} — ${radio.dataset.money}`;
    if (updateUrl) { const url = new URL(location.href); url.searchParams.set('variant', radio.value); history.replaceState({}, '', url); }
  }
});
if (!customElements.get('mm-gallery-collection')) customElements.define('mm-gallery-collection', class extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    this.ready = true;
    this.cards = [...this.querySelectorAll('[data-mmg-card]')];
    this.featured = ['00234','00580','08430','00530','01972','01973','00543','00591','09135','00223','08989','09303','00376','00529'];
    this.visibleLimit = 24;
    this.palette = 'all';
    this.querySelector('.mmg-controls').hidden = false;
    this.querySelector('.mmg-selects').hidden = false;
    this.addEventListener('input', e => { if (e.target.matches('[data-mmg-search]')) { this.visibleLimit = 24; this.render(); } });
    this.addEventListener('change', e => { if (e.target.matches('select')) { this.visibleLimit = 24; this.render(); } });
    this.addEventListener('click', e => {
      const palette = e.target.closest('[data-mmg-palette]');
      if (palette) { this.palette = palette.dataset.mmgPalette; this.visibleLimit = 24; this.querySelectorAll('[data-mmg-palette]').forEach(t => t.setAttribute('aria-pressed', String(t === palette))); this.render(); }
      if (e.target.closest('[data-mmg-more]')) {
        const before = this.visibleLimit;
        this.visibleLimit += 24;
        this.render();
        this.matches[before]?.focus({ preventScroll: true });
      }
      if (e.target.closest('[data-mmg-reset]')) {
        this.querySelector('[data-mmg-search]').value = '';
        this.querySelector('[data-mmg-format]').value = 'all';
        this.querySelector('[data-mmg-palette="all"]').click();
      }
    });
    this.render();
  }
  render() {
    const search = this.querySelector('[data-mmg-search]').value.trim().toLocaleLowerCase();
    const format = this.querySelector('[data-mmg-format]').value;
    const sort = this.querySelector('[data-mmg-sort]').value;
    const rank = c => { const r = this.featured.indexOf(c.dataset.code); return r < 0 ? 999 : r; };
    const ordered = [...this.cards].sort((a, b) => sort === 'az' ? a.dataset.title.localeCompare(b.dataset.title) : rank(a) - rank(b) || a.dataset.title.localeCompare(b.dataset.title));
    this.matches = ordered.filter(c => (this.palette === 'all' || c.dataset.palette === this.palette) && (format === 'all' || c.dataset.format === format) && `${c.dataset.title} ${c.dataset.code}`.toLocaleLowerCase().includes(search));
    const visible = new Set(this.matches.slice(0, this.visibleLimit));
    const grid = this.querySelector('.mmg-grid');
    ordered.forEach(c => { c.hidden = !visible.has(c); grid.appendChild(c); });
    const countText = this.dataset.countLabel.replace('COUNT', this.matches.length);
    this.querySelector('[data-mmg-count]').textContent = this.matches.length === 1 ? countText.replace(/works$/, 'work').replace(/Motive$/, 'Motiv') : countText;
    this.querySelector('.mmg-empty').hidden = this.matches.length !== 0;
    this.querySelector('[data-mmg-more]').hidden = this.matches.length <= this.visibleLimit;
  }
});
